<mat-card>

  <mat-card-content>
    <div class="flex flex-col w-full">
      <div class="flex flex-row w-full" *ngIf="followupLength==0">
        <span>Follow up Visits cannot be added until an initial site visit has been conducted.</span>
    </div>
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
        class="mat-elevation-z8">

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 10px;"></th>
          <td mat-cell *matCellDef="let visit" style="padding-left: 10px;align-items: center;">
            <div class="flex flex-row">
              <a title="Edit Follow up Site Visit" (click)="editFollowupSiteVisit(visit)"
                *ngIf="complaintId != null && complaintId > 0 && complaintId==visit.complaintId ">
                <mat-icon>edit</mat-icon></a>

              <span *ngIf="complaintId != null && complaintId > 0 && isAdmin">
                <span>&nbsp;</span>
                <a (click)="removeFollowupSiteVisit(visit)" title="Remove Follow-up Site Visit">
                  <mat-icon style="color:red;">delete</mat-icon></a>
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="complaintId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="complaintId != null && complaintId > 0">{{visit.complaintId}}</span>
            <a *ngIf="complaintId == null || complaintId == 0" (click)="gotoComplaint(visit)">
              {{visit.complaintId}}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="requiredImplementationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Remediation <br/>Plan Due Date</th>
          <td mat-cell *matCellDef="let visit">
            <div class="flex flex-row">
              <span style="color:red;">{{visit.requiredImplementationDate}}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="requiredVisitDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit<br />Due Date</th>
          <td mat-cell *matCellDef="let visit">
            <span style="color:red;">{{visit.requiredVisitDate}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="followupDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Date</th>
          <td mat-cell *matCellDef="let visit">
            <span class="text-danger" *ngIf="visit.followupDate == null || visit.followupDate.length == 0">
              <mat-icon style="color:red;">warning</mat-icon>
            </span>
            {{visit.followupDate}}
          </td>
        </ng-container>
        <ng-container matColumnDef="followupConducted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Follow up Conducted</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="visit.followupConducted != null && visit.followupConducted == 1">Yes</span>
            <span style="color:red;" *ngIf="visit.followupConducted == null || visit.followupConducted == 0">No</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="remediationResult">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Results/Reason</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="visit.remediationResult == 1 && visit.followupConducted == 1">The business completed the remediation plan successfully (complaint resolved).</span>
            <span *ngIf="visit.remediationResult == 2 && visit.followupConducted == 1">The business did NOT complete the remediation plan (forward this complaint to OHA).</span>
            <span *ngIf="visit.remediationResult == 3 && visit.followupConducted == 1">The business completed the remediation, and another violation was observed (forward this complaint to OHA).</span>
            <span *ngIf="visit.remediationResult == 4 && visit.followupConducted == 1">The business did NOT complete the remediation plan, and additional violations were observed (forward this complaint to OHA).</span>
            <span *ngIf="visit.remediationResult == 1 && visit.followupConducted == 0">Follow-up visit denied (forward to OHA).</span>
            <span *ngIf="visit.remediationResult == 2 && visit.followupConducted == 0">Other (explain in comments).</span>

            <br /><br />
            <span *ngIf="visit.remediationResult != null && visit.remediationResult != 1 && visit.followupConducted == 1" class="text-danger ">
              <span class="text-danger" *ngIf="visit.followupDate == null || visit.followupDate.length == 0">
                <mat-icon style="color:red;">warning</mat-icon>
              </span>
              This result requires you to forward this Complaint to OHA
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="siteVisitNotes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Visit Notes</th>
          <td mat-cell *matCellDef="let visit">
            <div *ngIf="!visit.allowEditing" style="white-space: pre-wrap;overflow-wrap: break-word;overflow:auto">{{visit.comments}}</div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
      </table>
    </div>
  </mat-card-content>

</mat-card>